module.exports = __webpack_public_path__ + "img/F4g.b3510999.svg";